module.exports = __webpack_public_path__ + "img/tickgreen-icon.ac5e03e6.svg";